import { Accordion, AccordionDetails, AccordionSummary, Divider, Grid } from '@mui/material'
import React, { useState } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from './../../../../../assets/styles/componentStyles/widgetComponentStyles/extensionDrawer.module.scss'

const FAQSectionData = (props: any) => {
    const { data, chatbotTheme } = props;

    const [faqQuestions, setFaqQuestions] = useState(data?.message_fields?.form_data)
    const [currentExpandedIndex, setCurrentExpandedIndex] = useState<number | null>(null);

    return (
        <Grid container direction={"column"} className={styles.extension_form_grid_style} gap={"12px"} flexWrap={"nowrap"}>
            <Grid item>
                 <span className={styles.extension_name_heading_style}>{data?.message_fields?.title}</span>
            </Grid>

            <Divider sx={{marginTop: "4px"}}/>

            {faqQuestions && faqQuestions?.length > 0 &&
                <Grid item className={styles.accordion_item_container}>
                    <Grid container direction={"column"} gap="12px" sx={{ fontSize: "15px", fontWeight: "500", paddingTop: "5px" }}>
                        {faqQuestions?.map((questions: any, ind: number) => {
                            return <Accordion 
                                key={ind} 
                                className={`${styles.agentAccordion} ${styles.accordion_global}`} 
                                expanded={currentExpandedIndex == ind}
                                sx={{ 
                                    // background: chatbotTheme?.chatbot_header_color ? chatbotTheme?.chatbot_header_color : "#F1F1F1", 
                                    // color: chatbotTheme?.chatbot_header_font_color ? chatbotTheme?.chatbot_header_font_color : "#000",
                                    // background: chatbotTheme?.system_msg_bg_color ? chatbotTheme?.system_msg_bg_color : "#F1F1F1", 
                                    // color: chatbotTheme?.system_msg_color ? chatbotTheme?.system_msg_color : "#000",
                                    background: chatbotTheme?.user_msg_bg_color ? chatbotTheme?.user_msg_bg_color : "#F1F1F1", 
                                    color: chatbotTheme?.user_msg_color ? chatbotTheme?.user_msg_color : "#000",
                                    boxShadow: "none" 
                                }}
                                onChange={() => {
                                    if (currentExpandedIndex == ind) {
                                        setCurrentExpandedIndex(null);
                                    }
                                    else {
                                        setCurrentExpandedIndex(ind);
                                    }
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon sx={{color: chatbotTheme?.user_msg_color ? chatbotTheme?.user_msg_color : "#000"}}/>}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                    sx={{ minHeight: "50px !important" }}
                                >
                                    <span className={styles.accordion_section_title}>{questions?.section_title}</span>
                                </AccordionSummary>
                                <AccordionDetails
                                    className="agentAccordion"
                                    sx={{ padding: "0px 16px 16px !important" }}
                                >
                                    <Grid container direction={"column"} gap={2} 
                                        sx={{ 
                                            border: `1px solid ${chatbotTheme?.chatbot_send_message_icon_color}`,
                                            backgroundColor: `${chatbotTheme?.system_msg_bg_color ? chatbotTheme?.system_msg_bg_color : "#FFF"} !important`,
                                            color: `${chatbotTheme?.system_msg_color ? chatbotTheme?.system_msg_color : "#000"} !important`,
                                            borderRadius: "8px", paddingBlock: "12px", width: "100%" 
                                        }}
                                    >
                                        {questions?.section_questions?.map((secQ: any, index : number) => {
                                            return <Grid item key={index}>
                                                <Grid container direction={"column"} gap={1} paddingInline={"12px"}>
                                                    <Grid item className={styles.accordion_question_style}>
                                                        {data?.message_fields?.flag_q && 
                                                            <span>{`Q: `}</span>
                                                        } 
                                                        {secQ.ques}
                                                    </Grid>
                                                    <Grid item className={styles.accordion_answer_style}>
                                                        <Grid container gap={"10px"}>
                                                            {secQ?.ans?.map((answers: any, ind: number) => {
                                                                return <Grid item key={ind}>
                                                                    {answers?.description}
                                                                </Grid>
                                                            })}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                {index != questions?.section_questions?.length - 1 && <Divider sx={{marginTop: "16px"}}/>}
                                            </Grid>
                                        })}
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        })}
                    </Grid>
                </Grid>
            }
        </Grid>
    )
}

export default FAQSectionData